import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/CardCourseForm.css";

const FALLBACK_COVER = "https://placehold.co/1200x628/png";

export default function CourseCard179({ item }) {
  const coverSrc = item?.coverSrc || FALLBACK_COVER;
  const title = item?.title || "-";
  const subTitle = item?.subTitle || "";
  const displayPrice = item?.displayPrice || "";
  const category = item?.category || "ทั้งหมด";

  return (
    <div className="card app-card course-card h-100">
      <div className="ratio ratio-16x9 bg-surface">
        <img
          src={coverSrc}
          className="card-img-top"
          alt={title}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
          onError={(e) => {
            e.currentTarget.src = FALLBACK_COVER;
          }}
        />
      </div>

      <div className="card-body">
        <div
          className="fw-semibold text-main"
          style={{
            lineHeight: 1.25,
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2,
            overflow: "hidden",
          }}
        >
          {title}
        </div>

        {subTitle ? (
          <div
            className="text-secondary small mt-1"
            style={{
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2,
              overflow: "hidden",
              lineHeight: 1.35,
            }}
          >
            {subTitle}
          </div>
        ) : null}

        <div className="d-flex align-items-center justify-content-between mt-2 gap-2">
          <div className="fw-semibold">
            {displayPrice ? (
              <span
                className={
                  displayPrice === "ราคาตามแพ็คเกจ"
                    ? "text-secondary"
                    : "text-main"
                }
              >
                {displayPrice}
              </span>
            ) : (
              <span className="text-secondary">-</span>
            )}
          </div>

          <span className="course-card-badge">{category}</span>
        </div>
      </div>
    </div>
  );
}